module.exports = __webpack_public_path__ + "static/media/IET_ON_CAMPUS.ba71cb84.png";